import React, { useEffect, useRef } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

type DetailAccordionProps = {
  title: string;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
};

const DetailAccordion: React.FC<DetailAccordionProps> = ({ title, open, onToggle, children }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const wasOpen = useRef(open);

  useEffect(() => {
    const previously = wasOpen.current;
    wasOpen.current = open;
    if (!open || previously) return;
    const el = rootRef.current;
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    buttonRef.current?.focus({ preventScroll: true });
  }, [open]);

  return (
    <div ref={rootRef} className="rounded-xl border border-gray-200 bg-white overflow-hidden scroll-mt-24">
      <button
        ref={buttonRef}
        type="button"
        className="w-full flex items-center gap-2 px-4 py-3 text-left"
        aria-expanded={open}
        onClick={onToggle}
      >
        {open ? <ChevronDown className="h-4 w-4 shrink-0 text-gray-600" /> : <ChevronRight className="h-4 w-4 shrink-0 text-gray-600" />}
        <span className="font-semibold text-gray-900">{title}</span>
      </button>
      {open && <div className="border-t border-gray-100 px-4 py-4">{children}</div>}
    </div>
  );
};

export default DetailAccordion;
